const _excluded = ["page"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { FundsScreenerList, FundsScreenerFilters } from '@finect/tabular-components/Modules';
import { Datalayer } from '@finect/front-gtm';
import { withParams } from '@finect/front-core/withParams';
import { Head } from '@finect/tabular-components/Head';
import { srri, getProductTypeLabel, getProductTypeBySlug, getFundsListPath } from '@finect/front-resources/Products';
import { withSubscriptions } from '@finect/front-core/User';
import { orderParams, parseOrderParam } from '../commons/IIC/utils/fundsFilters';
import { FamilyInsideNavigation } from '../commons/IIC/components';
import { getFundsWithFilter, addFundsWithFilter, getManagementCompanies, getCategories } from '../commons/store/fund/actions';
import { parseQueryString, setPropertyToFilter, getQueryStringFromFilters } from '../commons/IIC/utils';
import { withComparison } from '../commons/hocs';
const PER_PAGE = 24;
const FundsScreenerListWithComparison = withComparison(FundsScreenerList, {
  withDrawer: false,
  modelType: 'product'
});
const mapStateToProps = state => ({
  user: state.user.user,
  page: state.fund.fundList.page || 1,
  fetching: state.fund.fundList.fetching || false,
  fetched: state.fund.fundList.fetched,
  funds: state.fund.fundList.items,
  paging: state.fund.fundList.paging,
  filters: state.fund.filters,
  categories: state.fund.categories,
  managementCompanies: state.fund.managementCompanies,
  countries: state.fund.countries
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getFundsWithFilter,
    addFundsWithFilter,
    getManagementCompanies,
    getCategories
  }, dispatch)
});
class FundsList extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      view: 'table'
    });
    _defineProperty(this, "getPath", () => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const _this$props$filters = this.props.filters,
        {
          page
        } = _this$props$filters,
        filters = _objectWithoutProperties(_this$props$filters, _excluded);
      const queryString = getQueryStringFromFilters(filters);
      return `${getFundsListPath(this.props.theme, productType, {})}${queryString.length ? `?${queryString}` : ''}`;
    });
    _defineProperty(this, "sendApplicationsField", (name, value) => {});
    _defineProperty(this, "loadNextPage", () => {
      const {
        actions,
        page
      } = this.props;
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      actions.addFundsWithFilter(productType, this.props.filters, page + 1, PER_PAGE);
    });
    _defineProperty(this, "handleScroll", () => {
      if (typeof document === 'undefined') {
        return;
      }
      if (!document.documentElement) {
        return;
      }
      const OFFSET = 500;
      if (document.documentElement.offsetHeight - window.scrollY - window.innerHeight < OFFSET) {
        if (!this.props.fetching && this.props.funds.length < this.props.paging.totalItems) {
          this.loadNextPage();
        }
      }
    });
    _defineProperty(this, "handleLoadMoreClick", () => {
      this.loadNextPage();
    });
    _defineProperty(this, "handleManagementCompanyReturn", value => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      const filters = setPropertyToFilter(this.props.filters, 'company', checkedIDs);
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleCategoryReturn", value => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      const filters = setPropertyToFilter(this.props.filters, 'category', checkedIDs);
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleSRRIReturn", value => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      const filters = setPropertyToFilter(this.props.filters, 'srri', checkedIDs);
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleOriginReturn", value => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      const filters = setPropertyToFilter(this.props.filters, 'country', checkedIDs);
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleOrderChange", value => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      const filters = setPropertyToFilter(this.props.filters, 'order', checkedIDs.length ? checkedIDs[0] : null);
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleRestore", () => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const filters = {
        category: [],
        company: [],
        srri: [],
        country: []
      };
      this.props.actions.getFundsWithFilter(productType, filters, 1, PER_PAGE);
    });
    _defineProperty(this, "handleFollow", (product, follow) => {
      const {
        handleEntityFollow
      } = this.props;
      handleEntityFollow('product', 'subscribe', product, follow);
    });
    _defineProperty(this, "handleViewChange", view => {
      this.setState({
        view
      });
    });
  }
  static loadInitialData(store, cookies, match, params) {
    const {
      page = 1
    } = params;
    const productType = getProductTypeBySlug(match.params.typeSlug);
    return store.dispatch(getFundsWithFilter(productType, parseQueryString(params), page, PER_PAGE));
  }
  componentWillUnmount() {
    window && window.removeEventListener('scroll', this.handleScroll);
  }
  componentDidUpdate(prevProps) {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters)) {
      window && history.pushState('', getProductTypeLabel(productType, 'plural', 'lowercase'), this.getPath());
    }
  }
  componentDidMount() {
    window && window.addEventListener('scroll', this.handleScroll);
    const {
      page = 1
    } = this.props.params;
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (!this.props.fetched) {
      const filter = parseQueryString(this.props.params);
      this.props.actions.getFundsWithFilter(productType, filter, page, PER_PAGE);
    }
    this.props.actions.getManagementCompanies(productType);
    this.props.actions.getCategories(productType);
  }
  render() {
    const {
      filters,
      params,
      page
    } = this.props;
    const {
      view
    } = this.state;
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const activeCompanyId = filters.company && filters.company.length ? filters.company[0] : null;
    const activeCategoryId = filters.category && filters.category.length ? filters.category[0] : null;
    const activeSRRI = filters.srri && filters.srri.length ? filters.srri[0] : null;
    const activeOriginId = filters.country && filters.country.length ? filters.country[0] : null;
    const activeOrder = filters.order || null;
    const managementCompany = this.props.managementCompanies.find(element => element.id === activeCompanyId);
    const category = this.props.categories.find(element => element.id.toString() === activeCategoryId);
    const risk = srri.find(element => element.risk.toString() === activeSRRI);
    const origin = this.props.countries.find(element => element.id === activeOriginId);
    const order = orderParams.find(element => element.slug === (activeOrder ? parseOrderParam(activeOrder).slug : null));
    const title = productType.plural + (page > 1 ? ` - Página ${page}` : '');
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: title,
      description: `Lista de todos los ${productType.plural}`
    }), React.createElement(Datalayer, {
      id: "Scene",
      type: "ready",
      params: {
        pageType: 'fundsList',
        filters: params
      }
    }), React.createElement(Datalayer, {
      id: "Scene",
      type: "pageType",
      params: {
        pageType: 'fundsList',
        filters: params
      }
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "list"
    }), React.createElement(ContainerInner, {
      withInsideNavigation: true
    }, React.createElement(MainContent, {
      fullWidth: true
    }, React.createElement(FundsScreenerFilters, {
      view: view,
      productType: productType,
      funds: this.props.funds,
      paging: this.props.paging,
      fetching: this.props.fetching,
      managementCompany: managementCompany,
      category: category,
      risk: risk,
      order: order,
      origin: origin,
      categories: this.props.categories,
      managementCompanies: this.props.managementCompanies,
      origins: this.props.countries,
      orders: orderParams,
      onManagmentCompanyChange: this.handleManagementCompanyReturn,
      onCategoryChange: this.handleCategoryReturn,
      onSRRIChange: this.handleSRRIReturn,
      onOriginChange: this.handleOriginReturn,
      onOrderChange: this.handleOrderChange,
      onRestore: this.handleRestore,
      onViewChange: this.handleViewChange
    }), React.createElement(FundsScreenerListWithComparison, {
      view: view,
      filters: filters,
      productType: productType,
      funds: this.props.funds,
      fetching: this.props.fetching,
      page: this.props.page,
      paging: this.props.paging,
      onFollow: this.handleFollow,
      subscriptionsActions: this.props.subscriptionsActions,
      subscriptionsProps: this.props.subscriptionsProps,
      onLoadMoreClick: this.handleLoadMoreClick
    })))));
  }
}
export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(withParams(withTheme(FundsList))), ['products']);